import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { URL_MAP } from '../../shared/urlMap';
import { environment as ENV } from '../../../environments/environment';
import { Genero } from '../../models/genero/genero';

@Injectable({
  providedIn: 'root',
})
export class GenerosService {
  private apiUrl = `${ENV.HOST}${URL_MAP.API.GENEROS}`;
  constructor(private http: HttpClient) {}

  getGeneros(bajas: string = ''): Observable<Genero[]> {
    const body = {
      jsonParametros: JSON.stringify({ bajas }),
    };
    return this.http.post<Genero[]>(this.apiUrl, body);
  }
}
